module.exports = __webpack_public_path__ + "img/badge.8ab4662b.png";